import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const PHONE_INPUT_HINT = '10-digit US number, e.g. (956) 555-1234';

export function normalizePhoneDigits(value: string | null | undefined): string {
  const digits = String(value ?? '').replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    return digits.slice(1);
  }
  return digits;
}

export function formatUsPhone(value: string | null | undefined): string {
  const digits = normalizePhoneDigits(value);
  if (digits.length !== 10) {
    return String(value ?? '').trim();
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function phoneFormValue(value: string | null | undefined): string {
  const digits = normalizePhoneDigits(value);
  return digits.length === 10 ? formatUsPhone(digits) : String(value ?? '').trim();
}

export function phoneValidator(required = false): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = String(control.value ?? '').trim();
    if (!raw) {
      return required ? { required: true } : null;
    }
    if (normalizePhoneDigits(raw).length !== 10) {
      return { phone: true };
    }
    return null;
  };
}
